import { useState } from "react";
import Modal from "components/ui/modal/modal";
import { FaCogs } from "react-icons/fa";
import ParamFicheDePaie from "components/app/AuditComplet/SituationPro/ParamCaisse/ParamFicheDePaie";
import ActionButton from "components/ui/controls/action-button/ActionButton";

function ParamFicheDePaiePageModal(props) {
  const [modalOpen, setmodalOpen] = useState(false);

  return (
    <>
      <ActionButton onClick={() => setmodalOpen(true)} icon={FaCogs} title="Paramétrage de la fiche de paie" />

      <Modal
        width="80%"
        height="82%"
        title="Paramétrage de la fiche de paie"
        icon={<FaCogs />}
        visible={modalOpen}
        onClose={() => {
          setmodalOpen(false);
        }}
      >
        <ParamFicheDePaie
          Outil={props.Outil}
          ClientConjoint={props.ClientConjoint}
          onClose={() => {
            setmodalOpen(false);
          }}
        />
      </Modal>
    </>
  );
}

export default ParamFicheDePaiePageModal;
